import { atom, useAtom, useSetAtom } from 'jotai';

export type DeleteFlowModalContext = {
  isOpened: boolean;
  flowId: string;
  inUse: boolean;
  onSuccess?: () => void;
};
export const deleteFlowModalAtom = atom<DeleteFlowModalContext | null>();

export const useDeleteFlowModalContext = () => {
  return useAtom(deleteFlowModalAtom);
};

export const useSetDeleteFlowModalContext = () => {
  return useSetAtom(deleteFlowModalAtom);
};
